import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import React, { createContext, useEffect, useState, useContext } from "react";
import { Box, Button, Container } from "@mui/material";
import QMentisBreadCrumb from '../../custom-components/QMentisBreadCrumb';
import DownloadIcon from '@mui/icons-material/Download';
import { Typography } from '@mui/material'
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import TestCaseUI from '../../output-components/test-automation/TestCaseImported';
import Feature from '../../output-components/test-automation/FeatureFilesCreated';
import InputForm from '../../output-components/test-automation/PageSource';
import PageClass from '../../output-components/test-automation/PageClass';
import Locators from '../../output-components/test-automation/Locators';
import StepDefinition from '../../output-components/test-automation/StepDefinition';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { featureFiles, pageClassAPI, stepDefinitionAPI, updateGitHubProject } from '../../../services/webServices';
import { LoadingModalContext } from "../../main-pages/ServicePage";
import UploadBox from '../input-pages/UploadBox';
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import CommonDownload from "../../custom-components/CommonDownload";
import TestEnvironmentForm from '../../output-components/test-automation/TestEnvironment';
import MessagePopup from '../../popup-components/MessagePopup';
import BrowsePathPopup from '../../output-components/test-automation/BrowsePathPopup';
import { handleProgressBar } from "../../custom-components/ProgressBar/ProgressBarWithAPI";



export const TestCaseFlowDataContext = createContext(null);


const JavaSeleniumNewTestCaseOutputPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const [testCaseDetails, setTestCaseDetails] = useState([]);
  // const [featureFiles, setFeatureFiles] = useState("");
  // const [pageSources, setPageSources] = useState("");
  // const [locators, setLocators] = useState({});
  // const [pageClasses, setPageClasses] = useState("");
  // const [stepDefinitions, setstepDefinitions] = useState("");
  // const [downloadDialogOpen, setDownloadDialogOpen] = useState(false);

  const [testEnvironment, setTestEnviorment] = useState({});
  const [testCase, setTestCase] = useState({});
  const [featureFile, setFeatureFile] = useState('');
  const [pageSource, setPageSource] = useState('');
  const [locator, setLocator] = useState('');
  const [pageClass, setPageClass] = useState('');
  const [stepDefinition, setstepDefinition] = useState('');
  const { setLoadingState } = useContext(LoadingModalContext);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
  const [framework, setFramework] = useState('');
  const [gitPopup, setGitPopup] = useState(false);
  const [gitCredentials, setGitCredentials] = useState({});
  const [gitPopupMessage, setGitPopupMessage] = useState("Congratulations! Your Java Selenium project has been successfully updated.");
  const [prDetails, setPrDetails] = useState(null);
  const [pageSourceData, setPageSourceData] = useState(false);
  const [projectType, setProjectType] = useState('');


  useEffect(() => {
    console.log("=== JavaSeleniumNewTestCaseOutputPage useEffect ===");
    console.log("Full location.state:", location.state);
    console.log("Git credentials from location.state:", location.state?.gitCredentials);
    console.log("Framework from location.state:", location.state?.framework);
    console.log("Project type from location.state:", location.state?.projectType);

    setTestEnviorment(location.state?.testenvironmentdata || {});
    setTestCase(location.state?.testCaseData || {});
    setFeatureFile(location.state?.featureFileData || "");
    setPageSource(location.state?.pageSource || "");
    setLocator(location.state?.generatedLocators || {});
    setPageClass(location.state?.generatedPageclassData || "");
    setstepDefinition(location.state?.generatedStepDefinitionData || "");
    setFramework(location.state?.framework || "");
    setGitCredentials(location.state?.gitCredentials || {});
    setProjectType(location.state?.projectType || '');

    // Check if user came from proper flow
    if (!location.state?.framework || !location.state?.projectType) {
      console.warn("User may not have come from proper flow - missing framework or projectType");
    }
  }, [location.state?.testCaseData, location.state?.testenvironmentdata, location.state?.featureFileData, location.state?.pageSource, location.state?.generatedLocators, location.state?.generatedPageclassData, location.state?.generatedStepDefinitionData, location.state?.framework, location.state?.gitCredentials]);


  const breadCrumbs = [


    {
      title: "Test Case Details",
      status: Object.entries(testCase).length > 0
        ? "Completed"
        : Object.entries(testCase).length === 0
          ? "In Progress"
          : "Not Started",
    },
    // {
    //   title: "Feature Files",
    //   status:
    //     !!featureFile && featureFile !== ""
    //       ? "Completed"
    //       : Object.entries(testCase).length > 0
    //         ? "In Progress"
    //         : "Not Started",
    // },
    {
      title: "Introduce SUT",
      status:
        !!pageSource && pageSource !== ""
          ? "Completed"
          : Object.entries(testCase).length > 0
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Locators",
      status:
        Object.keys(locator).length > 0
          ? "Completed"
          : !!pageSource && pageSource !== ""
            ? "In Progress"
            : "Not Started",
    },
    // {
    //   title: "Page Class",
    //   status:
    //     !!pageClass && pageClass !== ""
    //       ? "Completed"
    //       : Object.keys(locator).length > 0
    //         ? "In Progress"
    //         : "Not Started",
    // },

    // {
    //   title: "Step Definition",
    //   status:
    //     (!!stepDefinition && stepDefinition !== "")
    //       ? "Completed"
    //       : !!pageClass && pageClass !== ""
    //         ? "In Progress"
    //         : "Not Started",
    // },
  ];

  const handleGeneratePageSource = async () => {
    setPageSourceData(true);
   
    // setLoading(true)
    // try {
    //   // Your API call to generate feature files
    //   const generatedFeatureFileResponse = await featureFiles(testCase);
    //   // Make sure to define testCasesData
    //   const generatedFeatureFile = generatedFeatureFileResponse.data;
    //   navigate(location.pathname, { state: { ...location.state, featureFileData: generatedFeatureFile }, replace: true })
    // }
    // catch (error) {
    //   const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
    //   setPopupMessage(errorMsg);
    //   setPopupOpen(true);
    //   if (error.response?.data?.Error === "Your session has expired.") {
    //     setSessionExpiredValue(true);
    //   }
    // }
    // finally {
    //   setLoading(false);
    // }
  };


  const primaryFieldsObject = getPrimaryFields(locator);
  const handleGitHubProject = async () => {
    console.log("=== handleGitHubProject called ===");
    console.log("Current gitCredentials state:", gitCredentials);
    console.log("Current testCase state:", testCase);
    console.log("Current locator state:", locator);

    // Validate that we have the required data
    if (!gitCredentials || Object.keys(gitCredentials).length === 0) {
      console.error("Git credentials validation failed - empty or missing");
      setPopupMessage("GitHub credentials are missing. Please go back to the framework selection page and configure your GitHub settings through the proper flow.");
      setPopupOpen(true);
      return;
    }

    // Validate specific git credential fields
    if (!gitCredentials.token) {
      console.error("Missing git credential fields:", gitCredentials);
      setPopupMessage("GitHub credentials are incomplete. Missing username, token, or repository name. Please go back and configure your GitHub settings properly.");
      setPopupOpen(true);
      return;
    }

    if (!testCase || Object.keys(testCase).length === 0) {
      setPopupMessage("Test case data is missing. Please upload test case details first.");
      setPopupOpen(true);
      return;
    }

    if (!locator || Object.keys(locator).length === 0) {
      setPopupMessage("Locator data is missing. Please generate locators first.");
      setPopupOpen(true);
      return;
    }

    // setLoading(true);
    let progressHanlder;
    progressHanlder = handleProgressBar({
      setLoadingState,
      totalDurationMs: 900000,
      messageList:
        [
          "Validating the request and preparing data",
          "Analyzing the existing code",
          "Generating test scenarios and locators",
          "Building the formatted test case payload for GitHub",
          "Creating GitHub workflow runner configuration",
          "Running GitHub workflow and awaiting PR creation",
          "Finalizing the response and returning workflow results"
        ],
      messageDurations: [
        30000,
        300000,
        300000,
        30000,
        60000,
        30000,
        150000,
      ]
    });


    try {
      // Extract test cases from testCase data
      const extractTestCases = (testCaseData) => {
        if (Array.isArray(testCaseData)) {
          return testCaseData;
        }

        // If testCaseData is an object, try to extract test cases from various possible structures
        const testCases = [];

        // Check for common test case properties
        if (testCaseData.testCases && Array.isArray(testCaseData.testCases)) {
          return testCaseData.testCases;
        }

        // Check for individual test case properties
        if (testCaseData.testCaseName || testCaseData.name || testCaseData.title) {
          testCases.push(testCaseData.testCaseName || testCaseData.name || testCaseData.title);
        }

        // Check for description or scenario
        if (testCaseData.description || testCaseData.scenario) {
          testCases.push(testCaseData.description || testCaseData.scenario);
        }

        // If we found specific test cases, return them
        if (testCases.length > 0) {
          return testCases;
        }

        // Otherwise, try to extract from object keys/values
        Object.keys(testCaseData).forEach(key => {
          if (typeof testCaseData[key] === 'string' && testCaseData[key].trim()) {
            testCases.push(testCaseData[key]);
          }
        });

        return testCases.length > 0 ? testCases : ['Automated test case'];
      };

      // Prepare the data to send to the web service according to backend expectations
      const requestData = {
        repositoryUrl: gitCredentials.repositoryUrl,
        token: gitCredentials.token,

        // testCases: extractTestCases(testCase),
        testCases: testCase,
        locators: locator,
        featureName: featureFile ? 'Feature file automation' : 'Test automation',
        baseBranch: gitCredentials.selectedBranch || 'main',
        reviewerEmails: gitCredentials.reviewerEmail ? [gitCredentials.reviewerEmail] : [],
        frameworkType :"BDD-Selenium-Java"
      };

      console.log("Sending data to GitHub service:", requestData);
      console.log("Git credentials:", gitCredentials);
      console.log("Test case data:", testCase);
      console.log("Locator data:", locator);
      console.log("Extracted test cases:", requestData.testCases);

      progressHanlder.start();
      // Call the web service
      const response = await updateGitHubProject(requestData);
      await progressHanlder.finishAndClose();

      console.log("GitHub service response:", response);

      // Store PR details for display
      if (response.data && response.data.success) {
        setPrDetails({
          pullRequestUrl: response.data.data?.pullRequestUrl || null,
          repository: response.data.data?.repository || `${gitCredentials.username}/${gitCredentials.repoName}`,
          branch: response.data.data?.branch || null,
          filesCreated: response.data.data?.filesCreated || 0,
          executionTime: response.data.executionTime || null
        });

        setGitPopupMessage("Congratulations! Your Java Selenium project has been successfully updated.");
      } else {
        setPrDetails(null);
        setGitPopupMessage("Project updated successfully!");
      }
      setGitPopup(true);

    } catch (error) {
      console.error("Error updating GitHub project:", error);
      const errorMsg = error?.response?.data?.Error || error?.response?.data?.message || "An error occurred while updating the GitHub project. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      // setLoading(false);
      if (progressHanlder) {
        progressHanlder.stop();
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
  }
  const handleStepDefinition = async () => {
    // setLoading(true);
    let progressHanlder;
    progressHanlder = handleProgressBar({ setLoadingState, totalDurationMs: 6000 });
    try {
      progressHanlder.start("Generating");
      const pageClassData = {
        "pageClassGenerated": pageClass
      };
      const generatedStepDefinitionGenerated = await stepDefinitionAPI({ featureFileGenerated: featureFile, pageClassData }, location.state?.framework);
      const generatedStepDefinition = generatedStepDefinitionGenerated.data;
      await progressHanlder.finishAndClose();
      navigate(location.pathname, { state: { ...location.state, generatedStepDefinitionData: generatedStepDefinition }, replace: true });
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
      setLoadingState({ open: false, message: "", progress: null });
    }
    finally {
      // setLoading(false);
      if (progressHanlder) {
        progressHanlder.stop();
      }
      setLoadingState({ open: false, message: "", progress: null });
    }

  }

  function getPrimaryFields(response) {
    const primaryFields = {};
    for (const key in response) {
      if (response[key].primary) {
        if (response[key].primary[0].startsWith("class")) {
          primaryFields[key] = response[key].secondary;
        } else {
          primaryFields[key] = response[key].primary;
        }
      }
    }
    return primaryFields;
  };
  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };
  const testcaseNextButton = {
    label: "Continue",
    onClick: handleGeneratePageSource,
    startIcon: <GenerateButton />,
    variant: "contained",
    sx: { float: "right" },
  };

  const javaSeliniumDownloadButton = {
    label: "Download",
    onClick: handleDownloadClick,
    variant: "text",
    startIcon: <SaveAltRoundedIcon />,
    sx: { textTransform: "none" },
  };

  const locatorsNextButton = {
    label: "Update GitHub Project",
    variant: "contained",
    onClick: handleGitHubProject,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }
  const stepDefinitionNextButton = {
    label: "Generate Step Definition",
    variant: "contained",
    onClick: handleStepDefinition,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }
  const handleCloseDownload = () => {
    setDownloadOpen(false);
  }
  const formatTestPlan = (testPlanData) => {
    const formattedTestPlan = {};
    Object.entries(testPlanData).map(([key, value]) => {
      // console.log(typeof value);
      // console.log(value)
      if (Array.isArray(value)) {
        return (formattedTestPlan[key] = flattenArray(value));
      }
      if (!!value && typeof value === "object") {
        return (formattedTestPlan[key] = flattenObject(value));
      }
      return (formattedTestPlan[key] = value);
    });
    // console.log(formattedTestPlan)
    return formattedTestPlan;
  };


  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >

      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0", // Adjust this value as needed to place the breadcrumb where you want it
            width: "100%",
            zIndex: 1000, // Ensure it stays above other content
            bgcolor: "white", // Background color to prevent transparency
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Optional shadow for visual separation
          }}
        >


          <QMentisBreadCrumb breadCrumbs={breadCrumbs} sx={{ height: "56px" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              margin: "10px auto",
              "& > *:not(:last-child)": {
                marginBottom: "16px", // Adds margin between components but not after the last one
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate automated test scripts
                </Typography>
              </Box>
              <FullscreenToggle />




            </Box>
            {/* JAVA SELENIUM COMPONENTS */}
            {/* {Object.entries(testEnvironment).length === 0 && ( */}
            {/* <TestEnvironmentForm
              testEnvironmentData={testEnvironment}
              setTestEnviorment={setTestEnviorment}
              framework={location.state?.framework}
              confirmed={confirmed}
              setConfirmed={setConfirmed}
            /> */}
            {/* )} */}

            {/* <UploadBox testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} /> */}

            <UploadBox
              testCaseData={testCase}
              setTestCase={setTestCase}
              testcaseNextButton={testcaseNextButton}
              javaSeliniumDownloadButton={javaSeliniumDownloadButton}
            />

            {Object.entries(testCase).length > 0 && <TestCaseUI testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} PageSource={pageSourceData}  projectType={projectType}/>}
            {/* {!!featureFile && featureFile !== "" && <Feature featureFile={featureFile} setFeatureFile={setFeatureFile} />} */}
            {pageSourceData && <InputForm setPageSource={setPageSource} />}
            {Object.entries(locator).length > 0 && <Locators locator={locator} setLocator={setLocator} locatorsNextButton={locatorsNextButton} />}
            {/* {!!pageClass && pageClass !== "" && <PageClass pageClass={pageClass} setPageClass={setPageClass} featureFile={featureFile}
              stepDefinitionNextButton={stepDefinitionNextButton}
            />}
            {!!stepDefinition && stepDefinition !== "" && <StepDefinition stepDefinition={stepDefinition} setstepDefinition={setstepDefinition} featureFile={featureFile} pageClass={pageClass} framework={location.state?.framework} />} */}
          </Box>
        </Box>
        {/* Add padding-top to avoid overlap with the fixed breadcrumb */}
        <Container
          sx={{
            // paddingTop: "50px", // Adjust this value based on the height of the breadcrumb
            width: "100%",
          }}
        >


          {/* <TestCaseFlowDataContext.Provider
            value={{
              testCaseDetails,
              setTestCaseDetails,
              featureFiles,
              setFeatureFiles,
              pageSources,
              setPageSources,
              locators,
              setLocators,
              pageClasses,
              setPageClasses,
              stepDefinitions,
              setstepDefinitions,

            }}
          > */}


          {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
              <Button
                startIcon={<DownloadIcon />}
                color="#80c3d8"
                sx={{ textTransform: "none", marginRight: '15px', color: '#53adcb', border: '2px solid #53adcb', }}
              >
                Upload
              </Button>
            </Box> */}



          {/* </TestCaseFlowDataContext.Provider> */}
        </Container>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI tools.
        </Typography>
      </Box>
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
      <BrowsePathPopup
        open={gitPopup}
        handleClose={() => setGitPopup(false)}
        text1={gitPopupMessage}
        prDetails={prDetails}
      />

      <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
        wordData={[
          {
            type: "subParagraphs",
            data: testCase,
          },
        ]}
        serviceName={"Test Case Details"}
        serviceResponse={formatTestPlan(testCase)}
        documents={['xls', 'csv']}
      />
    </Box>
  );
};


export default JavaSeleniumNewTestCaseOutputPage;